module.exports = __webpack_public_path__ + "static/media/south-east-technological.e8659d9e.png";